import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { Reducer } from 'redux';

export enum EDataExportsType {
  equipmentReplicatedServicesReport = 'equipmentReplicatedServicesReport', // relatorio de todos os ultimos servicos de cada tipo de um determinado equipamento
  equipmentReplicatedServicesWithAttachmentsReport = 'equipmentReplicatedServicesWithAttachmentsReport', // relatorio de todos os ultimos servicos de cada tipo de um determinado equipamento com anexos
}

export enum EDataExportsStatus {
  scheduled = 'scheduled',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
}

export interface IDataExport {
  _id: string,
  tenant: string,
  type: EDataExportsType,
  file: string,
  payload: any,
  status: EDataExportsStatus,
  createdBy: { _id: string, name: string },
  createdByAccess: string,
  createdAt: Date,
  updatedAt: Date,
  downloadedBy: string[],
  logs: {
    message: string,
    date: Date,
  }[]
}

export interface IDataExportsState {
  dataExports: { count: number, rows: Array<IDataExport> }
  loading: boolean
  loadingFile: boolean
  loadingFileId: string
}

const initialState: IDataExportsState = {
  dataExports: { count: 0, rows: [] },
  loading: false,
  loadingFile: false,
  loadingFileId: '',
};

const requestDataExportsStart = (state: IDataExportsState, action: { isPooling: boolean }): IDataExportsState => {
  return updateObject(state, { loading: !action.isPooling });
};

const fetchDataExportsSuccess = (state: IDataExportsState, action: any) => {
  return updateObject(state, {
    dataExports: action.payload,
    loading: false
  });
};

const requestDataExportsFail = (state: IDataExportsState) => {
  return updateObject(state, { loading: false });
};

const requestSignDataExportStart = (state: IDataExportsState, action: { payload: string }): IDataExportsState => {
  return updateObject(state, { loadingFile: true, loadingFileId: action.payload });
};

const fetchSignDataExportSuccess = (state: IDataExportsState) => {
  return updateObject(state, { loadingFile: false, loadingFileId: '' });
};

const requestSignDataExportFail = (state: IDataExportsState) => {
  return updateObject(state, { loadingFile: false, loadingFileId: '' });
};

const reducer: Reducer<IDataExportsState> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.REQUEST_DATA_EXPORTS_START: return requestDataExportsStart(state, action);
    case actionTypes.FETCH_DATA_EXPORTS_SUCCESS: return fetchDataExportsSuccess(state, action);
    case actionTypes.REQUEST_DATA_EXPORTS_FAIL: return requestDataExportsFail(state);
    case actionTypes.REQUEST_SIGN_DATA_EXPORT_START: return requestSignDataExportStart(state, action);
    case actionTypes.FETCH_SIGN_DATA_EXPORT_SUCCESS: return fetchSignDataExportSuccess(state);
    case actionTypes.REQUEST_SIGN_DATA_EXPORT_FAIL: return requestSignDataExportFail(state);
    default: return state;
  }
};

export default reducer;
